import React from "react";
import Styles from "./CompanyDetails.module.css";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { profileCompanyDisplay } from "../../../commons/Profile";
import { useSelector } from "react-redux";
import { usePdfPreview } from "../../../hooks/usePdfPreview";

const DetailElement = ({
  detail,
  companyData,
  userData,
  userType,
  sectionType,
  handlePreviewGeneralTerms,
}) => {
  let actualValue;
  if (detail?.addressType === "office" && companyData?.companyOfficeAddress) {
    actualValue = companyData.companyOfficeAddress[detail?.value];
  } else if (
    detail?.addressType === "correspondence" &&
    companyData?.companyCorrespondenceAddress
  ) {
    actualValue = companyData.companyCorrespondenceAddress[detail?.value];
  } else if (
    detail?.addressType === "bank" &&
    companyData?.companyBankAccount
  ) {
    actualValue = companyData.companyBankAccount[detail?.value];
  } else if (
    sectionType === "companyBankAccount" &&
    companyData?.companyBankAccount
  ) {
    actualValue = companyData.companyBankAccount[detail?.value];
  } else if (
    sectionType === "companyDocumentMapping" &&
    companyData?.companyDocumentMapping
  ) {
    actualValue = companyData?.companyDocumentMapping[detail?.value];
  } else {
    actualValue =
      (userData && userData[detail?.value] != null
        ? userData[detail?.value]
        : null) ??
      (companyData && companyData[detail?.value] != null
        ? companyData[detail?.value]
        : null) ??
      undefined;
  }
  const displayDesc = companyData?.description;
  let displayValue;
  if (
    detail?.value === "userRole" ||
    detail?.value === "role" ||
    detail?.value === "activeRole" ||
    detail?.value === "userType" ||
    detail?.value === "roles"
  ) {
    let roleValue = userType;

    if (!roleValue && userData?.roles) {
      roleValue = Array.isArray(userData.roles)
        ? userData.roles.join(", ")
        : userData.roles;
    }

    if (!roleValue) {
      roleValue = actualValue;
    }

    displayValue =
      roleValue && roleValue !== "NA" ? roleValue : detail.defaultValue || "-";
  } else {
    if (sectionType === "companyBankAccount") {
      displayValue =
        actualValue && actualValue !== "NA"
          ? actualValue
          : detail.defaultValue || "-";
    } else {
      displayValue =
        (actualValue && actualValue !== "NA") ||
        (displayDesc && displayDesc !== "NA")
          ? actualValue || "-"
          : detail.defaultValue || "-";
    }
  }

  if (detail?.disp === "0") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "1") {
    return (
      <div className={Styles.eachDetailElement1}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "2") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        {actualValue && actualValue !== 0 ? (
          <div
            className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            style={{ cursor: "pointer" }}
            onClick={() => handlePreviewGeneralTerms(actualValue)}
          >
            <span>View</span>
            <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
          </div>
        ) : (
          <>{detail.defaultValue || "-"}</>
        )}
      </div>
    );
  }
  return null;
};

const DetailSection = ({
  item,
  companyData,
  userData,
  userType,
  handlePreviewGeneralTerms,
}) => {
  return (
    <div className={Styles.eachDetailSection}>
      <div className={Styles.sectionHeading}>
        <span>{item?.heading}</span>
      </div>
      <div className={Styles.eachDetailElementMainContainer}>
        {item?.details?.map((detail, idx) => (
          <DetailElement
            key={idx}
            detail={detail}
            companyData={companyData}
            userData={userData}
            userType={userType}
            sectionType={item?.type}
            handlePreviewGeneralTerms={handlePreviewGeneralTerms}
          />
        ))}
      </div>
    </div>
  );
};

const CompanyDetails = () => {
  const { companyDetails, loading, error } = useSelector(
    (state) => state.profileSlice
  );
  const userData = useSelector((state) => state.persistedReducer);
  const userDetails = userData?.user?.user;
  const userType = userData?.userType;

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  if (loading) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading company details...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
          Error loading company details: {error}
        </div>
      </div>
    );
  }

  return (
    <div className={Styles.detailsContainer}>
      {profileCompanyDisplay?.map((item, idx) => (
        <DetailSection
          key={idx}
          item={item}
          companyData={companyDetails}
          userData={userDetails}
          userType={userType}
          handlePreviewGeneralTerms={handlePreviewGeneralTerms}
        />
      ))}
      <PdfPreviewModal />
    </div>
  );
};

export default CompanyDetails;
